import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import classNames from 'classnames';
import parse from 'html-react-parser';

import DataTableListGenericaRaw from '../components/DataTableListGenerica/DataTableListGenericaRaw'

import HTMLtoDOCX from 'html-to-docx';
import { saveAs } from 'file-saver';
import { asBlob } from 'html-docx-ts'


import { Chart } from 'primereact/chart';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import { ChartConfiguration, TooltipItem, Scale } from 'chart.js/auto';




import React, { useRef, CSSProperties, useState, useEffect } from "react";
import ContentTemplate from "./ContentTemplate";
import '../assets/fonts/Anton-Regular-normal';
import { GenericaSistemaService } from '../service/GenericaSistemaService';
import './styleReport2.css'

interface GeneratePdfProps {
  metadata?: React.ReactNode[],
  genericasSistema?: React.ReactNode[],
  selectedTipoGenerica?: React.ReactNode,
  //tipoContenido?: 'portadaReporte' | 'portadaReporte'| 'cabeceraReporte'| 'cuerpoReporte'|  'piePaginaReporte'| 'resumenReporte',
}

//interface TipoContenido?: 'portadaReporte' | 'portadaReporte'| 'cabeceraReporte'| 'cuerpoReporte'|  'piePaginaReporte'| 'resumenReporte',

//const GeneratePdf: React.FC = (props: any) => {
const GeneratePdf = (props: GeneratePdfProps) => {



  const chartRef = useRef<any>(null);

  const divReportRef = useRef<any>(null);
  const portadaReporteRef = useRef<any>(null);
  const cabeceraReporteRef = useRef<any>(null);
  const piePaginaReporteRef = useRef<any>(null);
  const resumenReporteRef = useRef<any>(null);

  const cuerpoReporteRef = useRef<any>(null);

  //const structReportRef = useRef<any>(null);

  let widthPxPreviewWeb = "700px"
  let widthPxPdf_DEFAULT = (595 - 170)

  const [portadaReporte, setPortadaReporte] = useState(null);
  const [cabeceraReporte, setCabeceraReporte] = useState(null);
  const [cuerpoReporte, setCuerpoReporte] = useState(null);
  const [piePaginaReporte, setPiePaginaReporte] = useState(null);
  const [resumenReporte, setResumenReporte] = useState(null);
  const [widthPX, setWidthPx] = useState(widthPxPreviewWeb);
  const [esPDF, setEsPDF] = useState(false);

  const [comodin, setComodin] = useState(0);

  let chartsData = [];
  let chartsOptions = [];
  const documentStyle = getComputedStyle(document.documentElement);

  //let widthPX = (595 - 170) + "px"


  //let widthPX = "100%"


  const margins = {
    top: 60,
    bottom: 60,
    left: 30,
  };

  const handleGenerateWord = async () => {

    let HTML_Width = (595 - 150);
    let HTML_Height = 100;
    let PDF_Height = 100;
    var image

    /*
    html2canvas(cabeceraReporteRef.current, { allowTaint: true, scale: 2 }).then(function (canvas: any) {
      canvas.getContext('2d');
      image = canvas.toDataURL("image/png", 1.0);
      console.log("cab", image);
    });
    */
    setWidthPx(widthPxPdf_DEFAULT);
    setEsPDF(true);

    setTimeout(async () => {

      console.log("setTimeout");
      const doc = new jsPDF({
        format: "a4",
        unit: "px",
        compress: true
      });

      // Adding the fonts
      doc.setFont("Anton-Regular", "normal");

      let pageHeight = doc.internal.pageSize.getHeight();
      let pageWidth = doc.internal.pageSize.getWidth() - 20;

      let marginCuerpoReporte = [0];  // [top, right, bottom, left]

      if (cabeceraReporte !== "") {
        marginCuerpoReporte = [80, 10, 10, 10];  // [top, right, bottom, left]
      }
      else {
        marginCuerpoReporte = [10, 10, 10, 10];  // [top, right, bottom, left]
      }

      let htmlString = "";

      //htmlString = htmlString +cuerpoReporteRef.current.outerHTML+ htmlString;

      //import textCSSReport from './styleReport2.css';
      //const textCSSReport = require('./styleReport2.css').toString();

      let textCSS = "";
      await fetch("../assets/demo/styleReport2.csstxt")
        .then(r => r.text())
        .then(text => {
          textCSS = text;
        });



      htmlString = `<!DOCTYPE html>
<html lang="en">
    <head>
        <meta charset="UTF-8" />
        <title>Document</title>
        <style>
        `+ textCSS + `
</style>
    </head>
    <body>
        `+ cuerpoReporteRef.current.outerHTML + `
    </body>
</html>`;
      console.log(htmlString);

      /*
      
      const fileBuffer = await HTMLtoDOCX(htmlString, null, {
        table: { row: { cantSplit: true } },
        footer: true,
        pageNumber: true,
      });
      const file = new Blob([fileBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });

      saveAs(file, "h55tml-to-docx.docx");
      */




      const headerConfig = {
        leftStr: 'headerLeft',
        centerStr: 'headerCenter',
        rightStr: 'headerRight',
      }
      const footerConfig = {
        leftStr: 'footerLeft',
        centerStr: 'footerCenter',
        rightStr: 'pageNum',//param equal to 'pageNum', that will show the page numbers
      }

      asBlob(htmlString).then(blobData => {
        saveAs(blobData, `testDocument.docx`) // save as docx document
      })




      /*
      await doc.html(cuerpoReporteRef.current, {
        x: 0,
        y: 0,
        margin: marginCuerpoReporte,
        autoPaging: "text",
      });
      */
      /*
      autoTable(doc, {
        head: head,
        body: data,
        didDrawCell: (data) => { },
      });*/

      //await headerFooterFormatting(doc, doc.internal.pages.length);

      //doc.save("documento");

      setWidthPx(widthPxPreviewWeb);
      setEsPDF(false);

    }, 100);

  };

  const handleGeneratePdf = async () => {

    let HTML_Width = (595 - 150);
    let HTML_Height = 100;
    let PDF_Height = 100;
    var image

    /*
    html2canvas(cabeceraReporteRef.current, { allowTaint: true, scale: 2 }).then(function (canvas: any) {
      canvas.getContext('2d');
      image = canvas.toDataURL("image/png", 1.0);
      console.log("cab", image);
    });
    */
    setWidthPx(widthPxPdf_DEFAULT);
    setEsPDF(true);

    setTimeout(async () => {

      console.log("setTimeout");
      const doc = new jsPDF({
        format: "a4",
        unit: "px",
        compress: true
      });

      // Adding the fonts
      doc.setFont("Anton-Regular", "normal");

      let pageHeight = doc.internal.pageSize.getHeight();
      let pageWidth = doc.internal.pageSize.getWidth() - 20;

      let marginCuerpoReporte = [0];  // [top, right, bottom, left]

      if (cabeceraReporte !== "") {
        marginCuerpoReporte = [80, 10, 10, 10];  // [top, right, bottom, left]
      }
      else {
        marginCuerpoReporte = [10, 10, 10, 10];  // [top, right, bottom, left]
      }

      await doc.html(cuerpoReporteRef.current, {
        x: 0,
        y: 0,
        margin: marginCuerpoReporte,
        autoPaging: "text",
      });
      /*
      autoTable(doc, {
        head: head,
        body: data,
        didDrawCell: (data) => { },
      });*/

      await headerFooterFormatting(doc, doc.internal.pages.length);

      doc.save("documento");

      setWidthPx(widthPxPreviewWeb);
      setEsPDF(false);

    }, 100);

  };

  async function headerFooterFormatting(doc: jsPDF, totalPages: number) {

    let pageHeight = doc.internal.pageSize.getHeight();
    let pageWidth = doc.internal.pageSize.getWidth();

    const marginCabeceraReporte = [0, 10, 0, 10];  // [top, right, bottom, left]
    const marginPiePaginaReporte = [0, 10, 0, 10];  // [top, right, bottom, left]

    for (var i = totalPages; i >= 1; i--) {
      doc.setPage(i);
      //header
      await header(doc, i, totalPages, marginCabeceraReporte);

      await footer(doc, i, totalPages, marginPiePaginaReporte);
      //doc.addPage();
      //doc.page++;
    }
  };

  async function header(doc: jsPDF, pageNumber: number, totalPages: number, margin: number[]) {

    /*
    --image
    doc.addImage("", 'PNG', 15, 15, HTML_Width, HTML_Height - 10);
      for (var i = 1; i <= pageCount; i++) {
        doc.addPage();
        doc.addImage(image, 'PNG', 15, -(PDF_Height * i) + 15, HTML_Width, HTML_Height);
      }
*/

    let pageHeight = doc.internal.pageSize.getHeight();
    let pageWidth = doc.internal.pageSize.getWidth() - 20;

    await doc.html(cabeceraReporteRef.current, {
      x: 0,
      y: -(pageHeight * pageNumber) + 8,
      margin: margin
    });
    /*
    var strTop = 50
    var str = "Report Header Template";
    doc.setFontSize(18);
    //doc.setF('bold');

    doc.text(str, margins.left, strTop);

    doc.setLineCap(2);
    doc.line(3, strTop + 10, margins.width + 43, strTop + 10); // horizontal line
    */
  };

  async function footer(doc: jsPDF, pageNumber: number, totalPages: number, margin: number[]) {

    let pageWidth = doc.internal.pageSize.getWidth();
    var str = "Página " + pageNumber + " de " + totalPages
    doc.setFontSize(10);
    //doc.setFontStyle('normal');

    doc.text(str, pageWidth / 2 - (doc.getTextWidth(str) / 2), doc.internal.pageSize.height - 10, { baseline: 'bottom' });

    //doc.text(str, margins.left, doc.internal.pageSize.height - 10);


  };

  const replaceDataContenido = async (tipoContenido: string, contenido: string) => {

    //interface TipoContenido?: 'portadaReporte' | 'portadaReporte'| 'cabeceraReporte'| 'cuerpoReporte'|  'piePaginaReporte'| 'resumenReporte',
    let res = "";

    if (contenido !== undefined && contenido !== null && contenido !== "") {

      let val: string = contenido;
      let valTmp = "";

      let cantidadCamposComplex = 0; //val.split('[[{"operacion":"imagenURL"').length - 1;
      let indexPre = 0;
      let indexPos = 0;
      let campoComplex = "";
      let jsonStr = "";
      let obj = {};
      let newVal = "";

      cantidadCamposComplex = val.split("[[{").length - 1;

      for (let i = 0; i < cantidadCamposComplex; i++) {
        //console.log("for, ", i, cantidadCamposComplex);
        indexPre = val.indexOf("[[{");
        indexPos = val.indexOf("}]]");

        campoComplex = val.substring(indexPre, indexPos + 3)!;

        jsonStr = campoComplex.replace("[[", "").replace("]]", "");

        obj = JSON.parse(jsonStr);


        newVal = "";

        if (obj.operacion === "metadata") {

          let met = props?.metadata?.find(x => x.tg === obj.tg && x.campo === obj.campo)
          if (met !== null && met !== undefined) {
            newVal = met['ctiTexto'];
          }
          else {
            newVal = "Sin Titulo";
          }

          val = val.replace(campoComplex, newVal);

        }
        else if (obj.operacion === "data") {

          let data = props?.genericasSistema?.find(x => x.tg === obj.tg)

          if (Object.keys(data).includes(obj.campo) !== null && data.uts[obj.campo] !== undefined) {
            newVal = data.uts[obj.campo];
          }
          else {
            newVal = "Sin Dato";
          }

          val = val.replace(campoComplex, newVal);

        }

      }

      cantidadCamposComplex = val.split('[[S{"operacion":"imagenURL"').length - 1;

      for (let i = 0; i < cantidadCamposComplex; i++) {

        indexPre = val.indexOf('[[S{"operacion":"imagenURL"');

        valTmp = val.substring(indexPre, val.length)!;;

        indexPos = valTmp.indexOf("}S]]");

        campoComplex = val.substring(indexPre, indexPre + indexPos + 4)!;

        jsonStr = campoComplex.replace("[[S", "").replace("S]]", "");
        obj = JSON.parse(jsonStr);


        newVal = "";

        if (obj.operacion === "imagenURL") {

          const genericaSistemaService = new GenericaSistemaService();
          let fileBase64 = await genericaSistemaService.GetFileBase64(2, "ES", "userName", obj.val);

          newVal = "data:" + fileBase64.metadata + ";base64," + fileBase64.data;

          newVal = newVal || "Sin Titulo";

          val = val.replace(campoComplex, newVal);

        }

      }

      res = val;

    }

    return res;

  }

  const replaceDataContenidoComplex = async (tipoContenido: string, contenido: string) => {

    //interface TipoContenido?: 'portadaReporte' | 'portadaReporte'| 'cabeceraReporte'| 'cuerpoReporte'|  'piePaginaReporte'| 'resumenReporte',
    let res = [];

    if (contenido !== undefined && contenido !== null && contenido !== "") {

      let val: string = contenido;
      let valTmp = "";

      let cantidadCamposComplex = 0; //val.split('[[{"operacion":"imagenURL"').length - 1;
      let indexPre = 0;
      let indexPos = 0;
      let campoComplex = "";
      let jsonStr = "";
      let obj = {};
      let newVal = "";

      cantidadCamposComplex = val.split("[[{").length - 1;

      for (let i = 0; i < cantidadCamposComplex; i++) {
        //console.log("for, ", i, cantidadCamposComplex);
        indexPre = val.indexOf("[[{");
        indexPos = val.indexOf("}]]");

        campoComplex = val.substring(indexPre, indexPos + 3)!;

        jsonStr = campoComplex.replace("[[", "").replace("]]", "");

        obj = JSON.parse(jsonStr);


        newVal = "";

        if (obj.operacion === "metadata") {

          let met = props?.metadata?.find(x => x.tg === obj.tg && x.campo === obj.campo)
          if (met !== null && met !== undefined) {
            newVal = met['ctiTexto'];
          }
          else {
            newVal = "Sin Titulo";
          }

          val = val.replace(campoComplex, newVal);

        }
        else if (obj.operacion === "data") {

          let data = props?.genericasSistema?.find(x => x.tg === obj.tg)

          if (Object.keys(data).includes(obj.campo) !== null && data.uts[obj.campo] !== undefined) {
            newVal = data.uts[obj.campo];
          }
          else {
            newVal = "Sin Dato";
          }

          val = val.replace(campoComplex, newVal);

        }

      }

      cantidadCamposComplex = val.split('[[S{"operacion":"imagenURL"').length - 1;

      for (let i = 0; i < cantidadCamposComplex; i++) {

        indexPre = val.indexOf('[[S{"operacion":"imagenURL"');

        valTmp = val.substring(indexPre, val.length)!;;

        indexPos = valTmp.indexOf("}S]]");

        campoComplex = val.substring(indexPre, indexPre + indexPos + 4)!;

        jsonStr = campoComplex.replace("[[S", "").replace("S]]", "");
        obj = JSON.parse(jsonStr);


        newVal = "";

        if (obj.operacion === "imagenURL") {

          const genericaSistemaService = new GenericaSistemaService();
          let fileBase64 = await genericaSistemaService.GetFileBase64(2, "ES", "userName", obj.val);

          newVal = "data:" + fileBase64.metadata + ";base64," + fileBase64.data;

          newVal = newVal || "Sin Titulo";

          val = val.replace(campoComplex, newVal);

        }

      }

      res = [{ tipo: "html", contenido: val }];
      // para  campos que no parte el reporte
      //1 - 3
      //2 - 5
      //3 - 7
      //4 - 9

      let valPre = "";
      let valPost = "";

      //t - t - t - t - t
      cantidadCamposComplex = val.split('[[T{"operacion":"tabla"').length - 1;
      valPre = "";
      valPost = "";

      for (let i = 1; i <= cantidadCamposComplex; i++) {

        indexPre = val.indexOf('[[T{"operacion":"tabla"');

        valTmp = val.substring(indexPre, val.length)!;;

        indexPos = valTmp.indexOf("}T]]");

        campoComplex = val.substring(indexPre, indexPre + indexPos + 4)!;

        jsonStr = campoComplex.replace("[[T", "").replace("T]]", "");
        obj = JSON.parse(jsonStr);

        valPre = val.substring(0, indexPre)!;
        valPost = val.substring(indexPre + campoComplex.length, val.length)!;
        val = valPost;

        res[res.length - 1] = { tipo: "html", contenido: valPre };
        res.push({ tipo: "obj", contenido: obj });
        res.push({ tipo: "html", contenido: valPost });

        newVal = "";

        if (obj.operacion === "tabla22") {

          const genericaSistemaService = new GenericaSistemaService();
          let fileBase64 = await genericaSistemaService.GetFileBase64(2, "ES", "userName", obj.val);

          newVal = "data:" + fileBase64.metadata + ";base64," + fileBase64.data;

          newVal = newVal || "Sin Titulo";

          val = val.replace(campoComplex, newVal);

        }

      }

      // Graficos
      cantidadCamposComplex = val.split('[[G{"operacion":"grafico"').length - 1;
      valPre = "";
      valPost = "";

      for (let i = 1; i <= cantidadCamposComplex; i++) {

        indexPre = val.indexOf('[[G{"operacion":"grafico"');

        valTmp = val.substring(indexPre, val.length)!;;

        indexPos = valTmp.indexOf("}G]]");

        campoComplex = val.substring(indexPre, indexPre + indexPos + 4)!;

        jsonStr = campoComplex.replace("[[G", "").replace("G]]", "");
        obj = JSON.parse(jsonStr);

        valPre = val.substring(0, indexPre)!;
        valPost = val.substring(indexPre + campoComplex.length, val.length)!;
        val = valPost;

        res[res.length - 1] = { tipo: "html", contenido: valPre };
        res.push({ tipo: "obj", contenido: obj });
        res.push({ tipo: "html", contenido: valPost });

        newVal = "";

        if (obj.operacion === "tabla22") {

          const genericaSistemaService = new GenericaSistemaService();
          let fileBase64 = await genericaSistemaService.GetFileBase64(2, "ES", "userName", obj.val);

          newVal = "data:" + fileBase64.metadata + ";base64," + fileBase64.data;

          newVal = newVal || "Sin Titulo";

          val = val.replace(campoComplex, newVal);

        }

      }

      // vistas o subreportes
      cantidadCamposComplex = val.split('[[V{"operacion":"vista"').length - 1;
      valPre = "";
      valPost = "";

      for (let i = 1; i <= cantidadCamposComplex; i++) {

        indexPre = val.indexOf('[[V{"operacion":"vista"');

        valTmp = val.substring(indexPre, val.length)!;;

        indexPos = valTmp.indexOf("}V]]");

        campoComplex = val.substring(indexPre, indexPre + indexPos + 4)!;

        jsonStr = campoComplex.replace("[[V", "").replace("V]]", "");
        obj = JSON.parse(jsonStr);

        valPre = val.substring(0, indexPre)!;
        valPost = val.substring(indexPre + campoComplex.length, val.length)!;
        val = valPost;

        res[res.length - 1] = { tipo: "html", contenido: valPre };
        res.push({ tipo: "obj", contenido: obj });
        res.push({ tipo: "html", contenido: valPost });

        newVal = "";

        if (obj.operacion === "tabla22") {

          const genericaSistemaService = new GenericaSistemaService();
          let fileBase64 = await genericaSistemaService.GetFileBase64(2, "ES", "userName", obj.val);

          newVal = "data:" + fileBase64.metadata + ";base64," + fileBase64.data;

          newVal = newVal || "Sin Titulo";

          val = val.replace(campoComplex, newVal);

        }

      }


    }

    return res;

  }

  const replaceDataContenidoComplexSubReport = (tipoContenido: string, contenido: string) => {

    //interface TipoContenido?: 'portadaReporte' | 'portadaReporte'| 'cabeceraReporte'| 'cuerpoReporte'|  'piePaginaReporte'| 'resumenReporte',
    let res = [];

    if (contenido !== undefined && contenido !== null && contenido !== "") {

      let val: string = contenido;
      let valTmp = "";

      let cantidadCamposComplex = 0; //val.split('[[{"operacion":"imagenURL"').length - 1;
      let indexPre = 0;
      let indexPos = 0;
      let campoComplex = "";
      let jsonStr = "";
      let obj = {};
      let newVal = "";

      cantidadCamposComplex = val.split("[[{").length - 1;

      for (let i = 0; i < cantidadCamposComplex; i++) {
        //console.log("for, ", i, cantidadCamposComplex);
        indexPre = val.indexOf("[[{");
        indexPos = val.indexOf("}]]");

        campoComplex = val.substring(indexPre, indexPos + 3)!;

        jsonStr = campoComplex.replace("[[", "").replace("]]", "");

        obj = JSON.parse(jsonStr);


        newVal = "";

        if (obj.operacion === "metadata") {

          let met = props?.metadata?.find(x => x.tg === obj.tg && x.campo === obj.campo)
          if (met !== null && met !== undefined) {
            newVal = met['ctiTexto'];
          }
          else {
            newVal = "Sin Titulo";
          }

          val = val.replace(campoComplex, newVal);

        }
        else if (obj.operacion === "data") {

          let data = props?.genericasSistema?.find(x => x.tg === obj.tg)

          if (Object.keys(data).includes(obj.campo) !== null && data.uts[obj.campo] !== undefined) {
            newVal = data.uts[obj.campo];
          }
          else {
            newVal = "Sin Dato";
          }

          val = val.replace(campoComplex, newVal);

        }

      }

      cantidadCamposComplex = val.split('[[S{"operacion":"imagenURL"').length - 1;

      for (let i = 0; i < cantidadCamposComplex; i++) {

        indexPre = val.indexOf('[[S{"operacion":"imagenURL"');

        valTmp = val.substring(indexPre, val.length)!;;

        indexPos = valTmp.indexOf("}S]]");

        campoComplex = val.substring(indexPre, indexPre + indexPos + 4)!;

        jsonStr = campoComplex.replace("[[S", "").replace("S]]", "");
        obj = JSON.parse(jsonStr);


        newVal = "";

        if (obj.operacion === "imagenURL") {

          const genericaSistemaService = new GenericaSistemaService();
          let fileBase64 = genericaSistemaService.GetFileBase64(2, "ES", "userName", obj.val);

          newVal = "data:" + fileBase64.metadata + ";base64," + fileBase64.data;

          newVal = newVal || "Sin Titulo";

          val = val.replace(campoComplex, newVal);

        }

      }

      res = [{ tipo: "html", contenido: val }];
      // para  campos que no parte el reporte
      //1 - 3
      //2 - 5
      //3 - 7
      //4 - 9

      let valPre = "";
      let valPost = "";

      //t - t - t - t - t
      cantidadCamposComplex = val.split('[[T{"operacion":"tabla"').length - 1;
      valPre = "";
      valPost = "";

      for (let i = 1; i <= cantidadCamposComplex; i++) {

        indexPre = val.indexOf('[[T{"operacion":"tabla"');

        valTmp = val.substring(indexPre, val.length)!;;

        indexPos = valTmp.indexOf("}T]]");

        campoComplex = val.substring(indexPre, indexPre + indexPos + 4)!;

        jsonStr = campoComplex.replace("[[T", "").replace("T]]", "");
        obj = JSON.parse(jsonStr);

        valPre = val.substring(0, indexPre)!;
        valPost = val.substring(indexPre + campoComplex.length, val.length)!;
        val = valPost;

        res[res.length - 1] = { tipo: "html", contenido: valPre };
        res.push({ tipo: "obj", contenido: obj });
        res.push({ tipo: "html", contenido: valPost });

        newVal = "";

        if (obj.operacion === "tabla22") {

          const genericaSistemaService = new GenericaSistemaService();
          let fileBase64 = genericaSistemaService.GetFileBase64(2, "ES", "userName", obj.val);

          newVal = "data:" + fileBase64.metadata + ";base64," + fileBase64.data;

          newVal = newVal || "Sin Titulo";

          val = val.replace(campoComplex, newVal);

        }

      }

      // Graficos replaceDataContenidoComplexSubReport
      cantidadCamposComplex = val.split('[[G{"operacion":"grafico"').length - 1;
      valPre = "";
      valPost = "";

      for (let i = 1; i <= cantidadCamposComplex; i++) {

        indexPre = val.indexOf('[[G{"operacion":"grafico"');

        valTmp = val.substring(indexPre, val.length)!;;

        indexPos = valTmp.indexOf("}G]]");

        campoComplex = val.substring(indexPre, indexPre + indexPos + 4)!;

        jsonStr = campoComplex.replace("[[G", "").replace("G]]", "");
        obj = JSON.parse(jsonStr);

        valPre = val.substring(0, indexPre)!;
        valPost = val.substring(indexPre + campoComplex.length, val.length)!;
        val = valPost;

        res[res.length - 1] = { tipo: "html", contenido: valPre };
        res.push({ tipo: "obj", contenido: obj });
        res.push({ tipo: "html", contenido: valPost });

        newVal = "";

        if (obj.operacion === "tabla22") {

          const genericaSistemaService = new GenericaSistemaService();
          let fileBase64 = genericaSistemaService.GetFileBase64(2, "ES", "userName", obj.val);

          newVal = "data:" + fileBase64.metadata + ";base64," + fileBase64.data;

          newVal = newVal || "Sin Titulo";

          val = val.replace(campoComplex, newVal);

        }

      }

      // vistas o subreportes
      cantidadCamposComplex = val.split('[[V{"operacion":"vista"').length - 1;
      valPre = "";
      valPost = "";

      for (let i = 1; i <= cantidadCamposComplex; i++) {

        indexPre = val.indexOf('[[V{"operacion":"vista"');

        valTmp = val.substring(indexPre, val.length)!;;

        indexPos = valTmp.indexOf("}V]]");

        campoComplex = val.substring(indexPre, indexPre + indexPos + 4)!;

        jsonStr = campoComplex.replace("[[V", "").replace("V]]", "");
        obj = JSON.parse(jsonStr);

        valPre = val.substring(0, indexPre)!;
        valPost = val.substring(indexPre + campoComplex.length, val.length)!;
        val = valPost;

        res[res.length - 1] = { tipo: "html", contenido: valPre };
        res.push({ tipo: "obj", contenido: obj });
        res.push({ tipo: "html", contenido: valPost });

        newVal = "";

        if (obj.operacion === "tabla22") {

          const genericaSistemaService = new GenericaSistemaService();
          let fileBase64 = genericaSistemaService.GetFileBase64(2, "ES", "userName", obj.val);

          newVal = "data:" + fileBase64.metadata + ";base64," + fileBase64.data;

          newVal = newVal || "Sin Titulo";

          val = val.replace(campoComplex, newVal);

        }

      }

    }

    return res;

  }

  useEffect(() => {

    let tgViewReport = props?.selectedTipoGenerica?.operaciones.find(x => x.tipoOperacion === "VIEW" && x.seccion === "REPORT");

    let gsViewReport = props?.genericasSistema?.find(x => x.tg === tgViewReport.tgRef);

    let portadaReporte = null;
    let cabeceraReporte = null;
    let cuerpoReporte = null;
    let piePaginaReporte = null;
    let resumenReporte = null;

    /*
    setStructReportRef({
      portadaReporte: null,
      cabeceraReporte: null,
      cuerpoReporte: null,
      piePaginaReporte: null,
      resumenReporte: null,
    });
    */


    replaceDataContenidoComplex("cuerpoReporte", gsViewReport.uts.cuerpoReporte).then((res: any[]) => {
      let newVal = res.map((value) => { return { ...value, ref: null } });
      setCuerpoReporte(newVal);
    });


    replaceDataContenido("cabeceraReporte", gsViewReport.uts.cabeceraReporte).then((res) => {
      setCabeceraReporte(res);
    });

    /*

    replaceDataContenido("portadaReporte", gsViewReport.uts.portadaReporte).then((res) => portadaReporte = res)
      .then(() => {
        replaceDataContenido("cabeceraReporte", gsViewReport.uts.cabeceraReporte).then((res) => cabeceraReporte = res);
      })
      .then(() => {
        replaceDataContenido("piePaginaReporte", gsViewReport.uts.piePaginaReporte).then((res) => piePaginaReporte = res);
      })
      .then(() => {
        replaceDataContenido("resumenReporte", gsViewReport.uts.resumenReporte).then((res) => resumenReporte = res);
      })
      .then(() => {



        setComodin((prev) => prev + 1);

      });
*/




    //let portadaReporte = replaceDataContenido("portadaReporte", gsViewReport.uts.portadaReporte);
    //let cabeceraReporte = replaceDataContenido("cabeceraReporte", gsViewReport.uts.cabeceraReporte);
    //let cuerpoReporte = replaceDataContenido("cuerpoReporte", gsViewReport.uts.cuerpoReporte);
    //let piePaginaReporte = replaceDataContenido("piePaginaReporte", gsViewReport.uts.piePaginaReporte);
    //let resumenReporte = replaceDataContenido("piePaginaReporte", gsViewReport.uts.resumenReporte);


  }, [])

  const RenderContenidoComplexSubReport = (cuerpoReporte: Any) => {

    let htmlSubReport = replaceDataContenidoComplexSubReport("cuerpoReporte", genReporte.uts.cuerpoReporte);
    //replaceDataContenidoComplex("cuerpoReporte",genReporte.uts.cuerpoReporte).then((res: any[]) => {
    //htmlSubReport= res.map((value) => { return { ...value, ref: null } });
    //});

    return htmlSubReport.map(h => {
      if (h.tipo === "html") {
        return parse(h.contenido);
      }
      else {

        let metadataGensObj = [...props.metadata?.filter(t => t.tg === h.contenido.tg)];
        let gensObj = [...props.genericasSistema?.filter(t => t.tg === h.contenido.tg)];
        let selectedTipoGenericaGensObj = { ...props?.selectedTipoGenerica?.operaciones.find(t => t.tgRef === h.contenido.tg && t.tipoOperacion === "DATASET_REPORT" && t.seccion === "REPORT").tgRefConfig };

        return (
          <DataTableListGenericaRaw //className="bordered" 
            //groupRowsBy={groupRowsBy}
            selectedTipoGenerica={selectedTipoGenericaGensObj}
            metadataRef={metadataGensObj}
            genericasSistema={gensObj}
            camposAMostrar={h.contenido.campos}
          //etiquetasModulo={etiquetasModulo}
          >
          </DataTableListGenericaRaw>);

        return (<>Aún no tengo idea</>);
      }

    });

  }

  const SubReportRenderContenidoComplex = (x: Any, genS: Any, params: Any) => {

    //rounded text raised                         
    if (x.contenido.subreports !== undefined && x.contenido.subreports.length > 0) {

      return x.contenido.subreports.map(subr => {

        let cumple = true;

        if (subr['conds'] && subr["conds"].length > 0) {
          let condiciones = subr["conds"];


          condiciones.forEach(c => {

            //console.log("dddd",  x.contenido.tg, c.tgOrigen !== undefined && c.tgOrigen !== x.contenido.tg);
            let genEnc = (c.tgOrigen !== undefined && c.tgOrigen !== x.contenido.tg) ?
              props.genericasSistema?.find(g => g.tg === c.tgOrigen && g.uts[c.campo] + "" === c.valor)
              : genS.uts[c.campo] + "" === c.valor ? genS : undefined;

            cumple = cumple && genEnc !== undefined;
            //if (genEnc) console.log("genEnc, ", genEnc)
          });
        }
        if (cumple === true) {


          let genReporte = props.genericasSistema?.find(t => t.tg === subr.reporte);

          console.log("subr.reporte, ", subr.reporte, genReporte);

          //if (genReporte.tg === "RPT_REPORTE-RPT_CNA_SUBINFORME_RESULTADOS_CARACTERISTICA") {
          if (genReporte.tg.includes("RPT_CNA")) {  //esto hay que mejorarlo porque esta muy chambon
            subr.params.forEach(p => {
              p['valor'] = genS.uts[p['campo']]
            });
            console.log("xxxx", subr.params);
            let htmlContenidoComplexSubReport = replaceDataContenidoComplexSubReport("cuerpoReporte", genReporte.uts.cuerpoReporte);
            return RenderContenidoComplex(htmlContenidoComplexSubReport, 'dfasfsfsd', subr.params);
          }

          let htmlContenidoComplexSubReport = replaceDataContenidoComplexSubReport("cuerpoReporte", genReporte.uts.cuerpoReporte);



          return RenderContenidoComplex(htmlContenidoComplexSubReport);



        }
        else {
          return (<></>);
        }

      });

    }
    else {
      return (<></>);
    }

  }


  const colorList = ["blue", "green", "yellow", "cyan", "pink", "indigo", "teal", "orange", "bluegray", "purple", "red", "gray"];

  const RenderContenidoComplex = (contenidoReporte: Any, a: Any, params: Any) => {

    //rounded text raised   
    let cuerpoReporte2 = [...contenidoReporte];
    let selectedTipoGenerica1 = undefined;

    if (cuerpoReporte2 !== null && cuerpoReporte2.length > 0) {

      return (<>{
        cuerpoReporte2.map((x, index) => {

          if (x.tipo === "html") {
            if (x.contenido !== "") {
              return (<>{parse(x.contenido)}</>)
            }
            else {
              return (<></>);
            }
            //return <div ref={e => x.ref = e} dangerouslySetInnerHTML={{ __html: x.contenido }} />
          }
          else {

            let findOperacionTg = props?.selectedTipoGenerica?.operaciones.find(t => t.tgRef === x.contenido.tg && t.tipoOperacion === "DATASET_REPORT" && t.seccion === "REPORT");

            //console.log("prev, ", x.contenido.tg);

            //console.log("findOperacionTg, ", x.c ontenido.tg, findOperacionTg);
            selectedTipoGenerica1 = { ...findOperacionTg.tgRefConfig };

            if (selectedTipoGenerica1.tg === "BAS_REFERENCIA-REF_CNA_VSTA_PROCESO_ASPECTO_PARA_REPORTE") {
              var ddd33333 = "";
            }



            let metadataRefObj = [...props.metadata?.filter(t => t.tg === x.contenido.tg)];
            let genericasSistemaObj = [...props.genericasSistema?.filter(t => t.tg === x.contenido.tg)];

            if (params !== undefined) {
              params.forEach(p => {
                genericasSistemaObj = genericasSistemaObj.filter(t => t.uts[p['campo']] + "" === p['valor'] + "");
              });

            }

            let dato = selectedTipoGenerica1.ctiTexto

            if (x.contenido.operacion === "vista") {



              return (<>
                {genericasSistemaObj.map(genS => {

                  if (x.contenido.tg === "BAS_REFERENCIA-REF_CNA_VSTA_PROCESO_FACTOR_PARA_REPORTE") {
                    var ss44444 = "";
                  }
                  else if (x.contenido.tg === "BAS_REFERENCIA-REF_CNA_VSTA_PROCESO_ASPECTO_PARA_REPORTE") {
                    var ss444424 = "";
                  }

                  if (a === "asdfadsf") {

                    return (
                      <>
                        <h5>{genS.uts[x.contenido.titulo]}</h5>
                        <div dangerouslySetInnerHTML={{ __html: genS.uts[x.contenido.cuerpo] }} />
                        <div dangerouslySetInnerHTML={{ __html: genS.uts[x.contenido.conclusion] }} />
                      </>
                    );
                  }

                  return (
                    <>
                      <h5>{genS.uts[x.contenido.titulo]}</h5>
                      <div dangerouslySetInnerHTML={{ __html: genS.uts[x.contenido.cuerpo] }} />
                      {

                        SubReportRenderContenidoComplex(x, genS)
                      }
                      <div dangerouslySetInnerHTML={{ __html: genS.uts[x.contenido.conclusion] }} />
                    </>
                  );
                })
                }
              </>);

            }
            else if (x.contenido.operacion === "grafico") {

              let genericasSistemaObjCabeceraFind = [];
              if (params !== undefined) {
                params.forEach(p => {
                  genericasSistemaObjCabeceraFind = props.genericasSistema?.filter(t => t.tg === "FMT_VSTA_RES_RESPUESTA_POWERBI_GROUP_BY_PREGUNTA").filter(t => t.uts[p['campo']] + "" === p['valor'] + "");
                });

              }

              //let genericasSistemaObjCabecera = [...props.genericasSistema?.filter(t => t.tg === x.contenido.tg)];

              let pregunta = genericasSistemaObjCabeceraFind[0];
              let respuestasEncuesta = genericasSistemaObj; //genericasSistemaDetalle.filter(x => x.uts["encuesta"] === generica.uts["encuesta"]);
              let detalles = respuestasEncuesta.filter(x => x.uts["pregunta"] === pregunta.uts["pregunta"]);

              let labels = [];
              let data = [];
              let backgroundColor = [];
              let hoverBackgroundColor = [];

              detalles.forEach((det, index) => {
                //console.log("ColorIndex", index)
                labels.push((det.uts["ctiTextovalor"] + "").substring(0, 15) + "...");
                data.push(det.uts["porcentaje"]);
                backgroundColor.push(documentStyle.getPropertyValue("--" + colorList[index] + "-500"));
                hoverBackgroundColor.push(documentStyle.getPropertyValue("--" + colorList[index] + "-400"));
              });

              //documentStyle.getPropertyValue('--blue-400'),
              //              documentStyle.getPropertyValue('--yellow-400'),
              //              documentStyle.getPropertyValue('--green-400')

              let tituloCompleto = pregunta.uts["ctiTextopregunta"];
              let title = [];
              let tituloRestante = "" + pregunta.uts["ctiTextopregunta"];
              let tamLinea = 150;


              for (var i = 0; i < 3; i++) {

                var segmento = tituloRestante.substring(0, tamLinea);
                title.push(segmento);

                tituloRestante = tituloRestante.substring(tamLinea, 1000);

              }

              let chartData = {}
              let chartOptions = {}
              let textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
              let surfaceBorder = documentStyle.getPropertyValue('--surface-border');
              let textColor = documentStyle.getPropertyValue('--text-color');

              if (true) {//esto para tipo barras

                chartData = {
                  //labels: ['A', 'B', 'C'],
                  labels: labels,
                  datasets: [
                    {
                      //data: [65, 59, 80, 81, 56, 55, 40],
                      //backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
                      //hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"]
                      label: '',
                      data: data,
                      backgroundColor: backgroundColor,
                      hoverBackgroundColor: hoverBackgroundColor,
                      simbolo: '%'

                    }
                  ],

                };

                chartOptions = {
                  maintainAspectRatio: false,
                  aspectRatio: 0.8,
                  plugins: {
                    legend: {
                      display: false,
                      labels: {
                        fontColor: textColor
                      },

                    },

                    datalabels: {

                      //size: 200,
                      //color: '#FFFFFF', // Set the color of the labels
                      //anchor: 'center', // Position the label (e.g., 'center', 'end', 'start')
                      //align: 'center',
                      formatter: (value, context) => {
                        // Format the display text (e.g., show the value)
                        return `${value}%`;
                      },
                      //font: {                        weight: 'bold' // Customize font                      }
                    },

                    tooltip: {
                      callbacks: {
                        label: function (context: TooltipItem<'bar'>) {
                          // 👈 Recuperamos el símbolo guardado en el dataset de forma limpia
                          const simbolo = context.dataset.simbolo || '';
                          return `${context.dataset.label}: ${context.parsed.y}${simbolo}`;
                        }
                      }
                    }

                  },
                  scales: {
                    x: {
                      ticks: {
                        color: textColorSecondary,
                        font: {
                          weight: 500
                        }
                      },
                      grid: {
                        display: false,
                        drawBorder: false
                      }
                    },
                    y: {
                      ticks: {
                        color: textColorSecondary
                      },
                      grid: {
                        color: surfaceBorder,
                        drawBorder: false
                      }
                    }
                  }
                };

              }
              else if (false) { //esto para tipo pie

                chartData = {
                  //labels: ['A', 'B', 'C'],
                  labels: labels,
                  datasets: [
                    {
                      //data: [65, 59, 80, 81, 56, 55, 40],
                      //backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
                      //hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"]

                      data: data,
                      backgroundColor: backgroundColor,
                      hoverBackgroundColor: hoverBackgroundColor
                    }
                  ],
                  datalabels: {
                    size: 100,
                    color: '#FFFFFF', // Set the color of the labels
                    anchor: 'center', // Position the label (e.g., 'center', 'end', 'start')
                    align: 'center',
                    formatter: (value, context) => {
                      // Format the display text (e.g., show the value)
                      return value;
                    },
                    font: {
                      weight: 'bold' // Customize font
                    }
                  }
                }
                chartOptions = {
                  plugins: {
                    title: {
                      display: true, title,
                      font: { size: 25 }, fullSize: true
                    },
                    legend: {
                      display: true,
                      labels: {
                        usePointStyle: false
                      }
                    }
                  }
                };

              }


              //if (selectedTipoGenerica1.tg === "BAS_REFERENCIA-REF_CNA_VSTA_PROCESO_FACTOR_PARA_REPORTE") {var ddd33333 = "";} 
              //let camposAMostrar = [...x.contenido.campos.split(",")];
              let groupRowsBy = x.contenido.groupRowsBy;



              return (
                <table>
                  <tr>
                    <td style={{ width: "60%" }}>
                      <h6>{tituloCompleto}</h6>
                      <Chart type="bar" ref={chartRef} data={chartData} options={chartOptions} //className="w-4"
                        plugins={[ChartDataLabels]}
                        style={{ width: "300px" }}
                      />

                    </td>
                    <td >
                      <DataTableListGenericaRaw className="bordered" groupRowsBy={groupRowsBy}
                        selectedTipoGenerica={{ ...selectedTipoGenerica1 }}
                        metadataRef={metadataRefObj}
                        genericasSistema={genericasSistemaObj}
                        camposAMostrar={x.contenido.campos}
                      //etiquetasModulo={etiquetasModulo}
                      >
                      </DataTableListGenericaRaw>
                    </td>

                  </tr>

                </table >

              );

            }

            else {

              if (selectedTipoGenerica1.tg === "BAS_REFERENCIA-REF_CNA_VSTA_PROCESO_FACTOR_PARA_REPORTE") {
                var ddd33333 = "";
              }
              else if (selectedTipoGenerica1.tg === "BAS_REFERENCIA-REF_CNA_VSTA_PROCESO_ASPECTO_PARA_REPORTE") {
                var ss444424 = "";
              }
              //let camposAMostrar = [...x.contenido.campos.split(",")];
              let groupRowsBy = x.contenido.groupRowsBy;

              return (
                <DataTableListGenericaRaw className="bordered" groupRowsBy={groupRowsBy}
                  selectedTipoGenerica={{ ...selectedTipoGenerica1 }}
                  metadataRef={metadataRefObj}
                  genericasSistema={genericasSistemaObj}
                  camposAMostrar={x.contenido.campos}
                //etiquetasModulo={etiquetasModulo}
                >
                </DataTableListGenericaRaw>);
            }


          }

        }
        )
      }
      </>);


    }
    else { return (<div ref={cuerpoReporteRef}></div>); }

  }




  if (cuerpoReporte === null) {
    return (<>nada</>)
  }
  else {

    console.log("tg ", props.genericasSistema)

    return (
      <div>



        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column"
          }}
        >
          <button
            style={{
              margin: "50px",
              padding: "10px",
              backgroundColor: "black",
              color: "white",
              fontFamily: "Anton",
              fontSize: "1.2rem",
              textTransform: "uppercase",
              letterSpacing: "0.1rem",
              cursor: "pointer",
              width: "200px"
            }}
            onClick={handleGeneratePdf}
          >
            Generar PDF
          </button>

          {
            (function () {

              if (props.selectedTipoGenerica.tg.includes("RPT_REPORTE-RPT_CNA_INFORME")) {
                //rounded text raised                         
                return (<button
                  style={{
                    margin: "50px",
                    padding: "10px",
                    backgroundColor: "black",
                    color: "white",
                    fontFamily: "Anton",
                    fontSize: "1.2rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.1rem",
                    cursor: "pointer",
                    width: "200px"
                  }}
                  onClick={handleGenerateWord}
                >
                  Generar Word
                </button>)
              }
              else return (<></>);

            })()
          }



          <div style={{ width: widthPxPreviewWeb }} className={classNames({ 'medioHTML': !esPDF, 'medioPDF': esPDF }, 'contenedorReporte')} ref={divReportRef} >

            {
              (function () {
                //rounded text raised                         
                if (portadaReporte !== null && portadaReporte !== "") {
                  return (
                    <div ref={portadaReporteRef}>
                      <ContentTemplate tipoContenido="portadaReporte" contenido={portadaReporte}
                        genericasSistema={props.genericasSistema} metadata={props.metadata}
                        selectedTipoGenerica={props.selectedTipoGenerica}
                      />
                    </div>
                  )
                    ;
                }
                else { return (<div ref={portadaReporteRef}></div>); }

              })()
            }

            {
              (function () {
                //rounded text raised                         
                if (cabeceraReporte !== null && cabeceraReporte !== "") {
                  return (
                    <div style={{ width: widthPX }}>
                      <div className="cabeceraReporte" ref={cabeceraReporteRef} dangerouslySetInnerHTML={{ __html: cabeceraReporte }} />
                    </div>

                  )
                    ;
                }
                else { return (<div ref={cabeceraReporteRef}></div>); }

              })()
            }

            {
              <div style={{ width: widthPX }} className="contenidoReporte" ref={cuerpoReporteRef}>
                {RenderContenidoComplex(cuerpoReporte)}
              </div>

            }

            {
              (function () {
                //rounded text raised                         
                if (piePaginaReporte !== null && piePaginaReporte !== "") {
                  return (
                    <div ref={piePaginaReporteRef}>
                      <ContentTemplate tipoContenido="piePaginaReporte" contenido={piePaginaReporte}
                        genericasSistema={props.genericasSistema} metadata={props.metadata}
                        selectedTipoGenerica={props.selectedTipoGenerica}
                      />
                    </div>
                  )
                    ;
                }
                else { return (<div ref={piePaginaReporteRef}></div>); }

              })()
            }

            {
              (function () {
                //rounded text raised                         
                if (resumenReporte !== null && resumenReporte !== "") {
                  return (
                    <div ref={resumenReporteRef}>
                      <ContentTemplate tipoContenido="resumenReporte" contenido={resumenReporte}
                        genericasSistema={props.genericasSistema} metadata={props.metadata}
                        selectedTipoGenerica={props.selectedTipoGenerica}
                      />
                    </div>
                  )
                    ;
                }
                else { return (<div ref={resumenReporteRef}></div>); }

              })()
            }



          </div>
        </div>
      </div>
    );



  }

};

export default GeneratePdf;
